import { render, staticRenderFns } from "./League.vue?vue&type=template&id=51586f36&"
import script from "./League.vue?vue&type=script&lang=js&"
export * from "./League.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports